import { Button, Dialog, MenuItem, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import {ProjectConfig} from 'Global';
import AutocompleteField from "elements/AutocompleteField";
import { ApiRequest } from "GlobalFunctions";

export default function ClientsEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, client_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();



  const defaultValues = {
    client_id: client_id ? client_id : "null",
    client_code: "",
    client_name: "",
    client_name2: "",
    client_last_name: "",
    client_last_name2: "",
    client_phone: "",
    client_address: "",
    location_region_id: "",
    location_city_id: "",
    client_email: "",
    business_name: "",
    document: "",
    neighborhood_id: "",
    typology_id: "",
    price_table: "",
    longitude: "",
    latitude: "",
    payment_method: "",
    paydays: "",
    credit: "",
    client_created_at: "",
    status: true,
    zone_id: "",
    visit_route: "",
    route_order: 0,
    document_type: "13",
    document_dv: "",
    person_type: "2",
    tax_regime: "O-99",
    tax_responsible: "0",
    postal_code: "",
    invoice_type: "0",
    group: "",
    subgroup: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (client_id) {
      axios.get(`${ProjectConfig.api_url}/clients/details`, {
        params: { client_id },
      })
      .then((response) => {
        console.log(response.data);
        setFormValues(response.data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
    } else {
      setFormValues(defaultValues);
    }
  }, [client_id]);

  const handleInputChange = (e: { target: { name: any; value: any }; }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const calcDV = (nit: any): string => {
    const cleaned = String(nit || '').replace(/[^0-9]/g, '');
    if (!cleaned) return '';
    const primes = [3,7,13,17,19,23,29,37,41,43,47,53,59,67,71];
    let sum = 0;
    for (let i = 0; i < cleaned.length; i++) {
      sum += parseInt(cleaned[cleaned.length - 1 - i]) * primes[i];
    }
    const mod = sum % 11;
    return mod >= 2 ? String(11 - mod) : String(mod);
  };

  const handleSubmit = async () => {  
    setLoading(true);

    await ApiRequest({
      url: "/clients/addedit",
      method: "POST",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: formValues,
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar('Marca guardada con éxito', { variant: 'success' });
          setOpenEditor(false);
          loadList();
          
        }else{
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        
      },
    });
  };


  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)} fullWidth maxWidth="md">
      <div className="DialogContainer" >
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Cliente</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">
            <h2>Información básica</h2>
            <div className='input_row'>
              <TextField
                id="client_code"
                name="client_code"
                label="Código"
                type="text"
                required
                fullWidth
                value={formValues.client_code}
                onChange={handleInputChange}
              />
            </div>

            <div className='input_row'>
              <TextField
                id="client_name"
                name="client_name"
                label="Nombre"
                type="text"
                required
                fullWidth
                value={formValues.client_name}
                onChange={handleInputChange}
              />
              <TextField
                id="client_name2"
                name="client_name2"
                label="Segundo nombre"
                type="text"
                fullWidth
                value={formValues.client_name2}
                onChange={handleInputChange}
              />
            </div>

            <div className='input_row'>
              <TextField
                id="client_last_name"
                name="client_last_name"
                label="Apellido"
                type="text"
                required
                fullWidth
                value={formValues.client_last_name}
                onChange={handleInputChange}
              />
              <TextField
                id="client_last_name2"
                name="client_last_name2"
                label="Segundo apellido"
                type="text"
                fullWidth
                value={formValues.client_last_name2}
                onChange={handleInputChange}
              />
            </div>

            <TextField
              id="business_name"
              name="business_name"
              label="Nombre del negocio"
              type="text"
              required
              fullWidth
              value={formValues.business_name}
              onChange={handleInputChange}
            />
          </div>
            
          <div className='input_group'>
            <h2>Información de contacto</h2>
            <div className='input_row'>
              <TextField
                id="client_phone"
                name="client_phone"
                label="Teléfono"
                type="text"
                required
                fullWidth
                value={formValues.client_phone}
                onChange={handleInputChange}
              />
              <TextField
                id="client_email"
                name="client_email"
                label="Email"
                type="text"
                fullWidth
                value={formValues.client_email}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className='input_group'>
            <h2>Información tributaria (DIAN)</h2>
            <TextField
              id="document_type"
              name="document_type"
              label="Tipo documento"
              select
              fullWidth
              value={formValues.document_type || "13"}
              onChange={(e) => {
                const val = e.target.value;
                const updates: any = { document_type: val };
                if (val === "31" && formValues.document) {
                  updates.document_dv = calcDV(formValues.document);
                } else {
                  updates.document_dv = "";
                }
                setFormValues({ ...formValues, ...updates });
              }}
            >
              <MenuItem value="13">CC - Cédula</MenuItem>
              <MenuItem value="31">NIT</MenuItem>
              <MenuItem value="22">CE - Cédula Extranjería</MenuItem>
              <MenuItem value="42">DEX - Documento Extranjero</MenuItem>
              <MenuItem value="50">NIT Extranjero</MenuItem>
              <MenuItem value="91">NUIP</MenuItem>
            </TextField>
            <div className='input_row'>
              <TextField
                id="document"
                name="document"
                label="Número documento"
                type="text"
                required
                fullWidth
                value={formValues.document}
                onChange={(e) => {
                  const val = e.target.value;
                  const updates: any = { document: val };
                  if (formValues.document_type === "31") {
                    updates.document_dv = calcDV(val);
                  }
                  setFormValues({ ...formValues, ...updates });
                }}
              />
              {formValues.document_type === "31" && (
                <TextField
                  id="document_dv"
                  name="document_dv"
                  label="DV"
                  type="text"
                  disabled
                  style={{ maxWidth: 80 }}
                  value={formValues.document_dv || ""}
                />
              )}
            </div>
            <div className='input_row'>
              <TextField
                id="person_type"
                name="person_type"
                label="Tipo persona"
                select
                fullWidth
                value={formValues.person_type || "2"}
                onChange={handleInputChange}
              >
                <MenuItem value="1">Jurídica</MenuItem>
                <MenuItem value="2">Natural</MenuItem>
              </TextField>
              <TextField
                id="tax_regime"
                name="tax_regime"
                label="Régimen fiscal"
                select
                fullWidth
                value={formValues.tax_regime || "O-99"}
                onChange={handleInputChange}
              >
                <MenuItem value="O-99">No responsable</MenuItem>
                <MenuItem value="O-13">Gran contribuyente</MenuItem>
                <MenuItem value="O-15">Autorretenedor</MenuItem>
                <MenuItem value="O-23">Agente de retención IVA</MenuItem>
                <MenuItem value="O-47">Régimen simple</MenuItem>
              </TextField>
            </div>
            <div className='input_row'>
              <TextField
                id="tax_responsible"
                name="tax_responsible"
                label="Responsable IVA"
                select
                fullWidth
                value={formValues.tax_responsible || "0"}
                onChange={handleInputChange}
              >
                <MenuItem value="0">No</MenuItem>
                <MenuItem value="1">Sí</MenuItem>
              </TextField>
              <TextField
                id="postal_code"
                name="postal_code"
                label="Código postal"
                type="text"
                fullWidth
                value={formValues.postal_code || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className='input_group'>
            <h2>Ubicación</h2>
            <TextField
              id="client_address"
              name="client_address"
              label="Dirección"
              type="text"
              required
              fullWidth
              value={formValues.client_address}
              onChange={handleInputChange}
            />

            <div className='input_row'>
              <AutocompleteField
                label="Departamento"
                endpoint="/clients/locationRegions"
                fullwidth
                dynamic
                max_results={10}
                value={formValues.location_region_id}
                onChange={(data: any) => setFormValues({ ...formValues, location_region_id: data?.value || "", location_city_id: "" })}
              />
              <AutocompleteField
                label="Ciudad"
                endpoint="/clients/locationCities"
                endpoint_params={{ region_id: formValues.location_region_id }}
                fullwidth
                dynamic
                max_results={10}
                disabled={!formValues.location_region_id}
                value={formValues.location_city_id}
                onChange={(data: any) => setFormValues({ ...formValues, location_city_id: data?.value || "" })}
              />
            </div>
            <div className='input_row'>
              <AutocompleteField 
                label="Barrio"
                fullwidth
                endpoint="/neighborhoods/list"
                value={formValues.neighborhood_id}
                onChange={(data: any) => setFormValues({ ...formValues, neighborhood_id: data.value })}
              />
            </div>

            <div className='input_row'>
              <TextField
                id="longitude"
                name="longitude"
                label="Longitud"
                type="text"
                required
                fullWidth
                value={formValues.longitude}
                onChange={handleInputChange}
              />
              <TextField
                id="latitude"
                name="latitude"
                label="Latitud"
                type="text"
                required
                fullWidth
                value={formValues.latitude}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className='input_group'>
            <h2>Ruta</h2>
            <div className='input_row'>
              <AutocompleteField
                label="Zona"
                endpoint="/zones/list"
                fullwidth
                value={formValues.zone_id}
                onChange={(data: any) => {
                  setFormValues({ ...formValues, zone_id: data?.value || "" });
                }}
              />
              <TextField
                id="visit_route"
                name="visit_route"
                label="Día de visita"
                type="text"
                fullWidth
                value={formValues.visit_route}
                onChange={handleInputChange}
              />
              <TextField
                id="route_order"
                name="route_order"
                label="Orden"
                type="number"
                fullWidth
                value={formValues.route_order}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className='input_group'>
            <h2>Información comercial</h2>
            <div className='input_row'>
              <AutocompleteField
                label="Tipología"
                fullwidth
                endpoint="/typology/list"
                value={formValues.typology_id}
                onChange={(data: any) => setFormValues({ ...formValues, typology_id: data.value })}
              />
              <TextField
                id="price_table"
                name="price_table"
                label="Tabla de precios"
                type="text"
                required
                fullWidth
                value={formValues.price_table}
                onChange={handleInputChange}
              />
            </div>

            <div className='input_row'>
              <TextField
                id="payment_method"
                name="payment_method"
                label="Método de pago"
                type="text"
                required
                fullWidth
                value={formValues.payment_method}
                onChange={handleInputChange}
              />
              <TextField
                id="paydays"
                name="paydays"
                label="Días de pago"
                type="text"
                required
                fullWidth
                value={formValues.paydays}
                onChange={handleInputChange}
              />
            </div>

            <div className='input_row'>
              <TextField
                id="credit"
                name="credit"
                label="Crédito"
                type="text"
                required
                fullWidth
                value={formValues.credit}
                onChange={handleInputChange}
              />
              <TextField
                id="status"
                name="status"
                label="Estado"
                type="text"
                required
                fullWidth
                value={formValues.status}
                onChange={handleInputChange}
              />
            </div>

            <TextField
              id="invoice_type"
              name="invoice_type"
              label="Tipo de factura"
              select
              fullWidth
              value={formValues.invoice_type ?? "0"}
              onChange={handleInputChange}
            >
              <MenuItem value="0">Factura electrónica</MenuItem>
              <MenuItem value="1">Orden de pedido</MenuItem>
            </TextField>

            <div className='input_row'>
              <TextField
                id="group"
                name="group"
                label="Grupo"
                type="text"
                fullWidth
                value={formValues.group || ""}
                onChange={handleInputChange}
              />
              <TextField
                id="subgroup"
                name="subgroup"
                label="Subgrupo"
                type="text"
                fullWidth
                value={formValues.subgroup || ""}
                onChange={handleInputChange}
              />
            </div>

            <TextField
              id="client_created_at"
              name="client_created_at"
              label="Fecha de creación"
              type="text"
              required
              fullWidth
              value={formValues.client_created_at}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">Cancelar</Button>
            <Button onClick={handleSubmit} variant="contained">Guardar</Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
